import {
  EducationalContent,
  EducationalSection
} from '../models/educational-content-page.interfaces';
import { BenefitsMocks } from './benefits.mocks';
import { WaysMocks } from './ways.mocks';

export const BenefitsLinkMocks = {
  label: 'See All Medallion Status Benefits',
  url: '/us/en/skymiles/medallion-program/medallion-benefits'
};

export const WaysLinkMocks = {
  label: 'Learn More About How To Reach Medallion Status',
  url: '/us/en/skymiles/medallion-program/how-to-qualify'
};

export const WaysSectionMocks: EducationalSection[] = [
  {
    header: {
      title: 'Ways to Earn MQDs',
      subtitle: ''
    },
    items: WaysMocks,
    action: WaysLinkMocks,
    note: '*Excludes taxes, fees (including government-imposed fees), Basic Economy and similar fares, gratuities, rooms service, other booking charges, and insurance, as applicable. Delta Stays and Delta Car Rentals must be booked through the delta.com portal to qualify, and Delta Vacations packages must be booked directly through the Delta Vacations portal. Other terms, exceptions, and exclusions apply. For additional details, visit our Terms and Conditions.'
  },
  {
    header: {
      title: 'Medallion Status Benefits',
      subtitle:
        'A sample of some of the most beloved benefits of the SkyMiles program. Upon reaching status, your benefits immediately take affect.'
    },
    items: BenefitsMocks,
    action: BenefitsLinkMocks
  }
];

export const BenefitsSectionMocks: EducationalSection = {
  header: {
    title: 'Medallion Status Benefits',
    subtitle:
      'A sample of some of the most beloved benefits of the SkyMiles program. Upon reaching status, your benefits immediately take affect.'
  },
  items: BenefitsMocks,
  action: BenefitsLinkMocks
};

export const IntroductionMocks = {
  header: {
    title: 'How Do I Earn Medallion Status with MQDs?',
    content:
      '<p>Your status progress is tracked with Medallion Qualification Dollars (MQDs), which are calculated based on the money you spend on Delta and qualifying partner products. To achieve status, you must complete <b>the MQD qualifier each year.</b></p><br><p>Note: For international members, your spending is automatically converted into Medallion Qualifying Dollars (MQDs) based on currency exchange rates.</p><br><a href="/us/en/skymiles/airline-credit-cards/international-credit-cards" target="_blank">How Is My Currency Converted?</a>'
  },
  requirements: {
    header: {
      subtitle: '(based on 2024 Activity)',
      title: '2025 Medallion Qualification Dollars Thresholds'
    },
    items: [
      {
        image: {
          alt: 'Earn Silver Medallion Logo image',
          src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/educational-content/silver-gallery.png'
        },
        label: {
          subtitle: '$6,000 MQDs',
          title: 'Silver Medallion'
        }
      },
      {
        image: {
          alt: 'Earn Gold Medallion Logo image',
          src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/educational-content/gold-gallery.png'
        },
        label: {
          subtitle: '$12,000 MQDs',
          title: 'Gold Medallion'
        }
      },
      {
        image: {
          alt: 'Earn Platinum Medallion Logo image',
          src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/educational-content/platinum-gallery.png'
        },
        label: {
          subtitle: '$18,000 MQDs',
          title: 'Platinum Medallion'
        }
      },
      {
        image: {
          alt: 'Earn Diamond Medallion Logo image',
          src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/educational-content/diamond-gallery.png'
        },
        label: {
          subtitle: '$35,000 MQDs',
          title: 'Diamond Medallion'
        }
      }
    ]
  },
  note: '*Excluding taxes and government-imposed fees'
};

export const EducationalContentPageMocks: EducationalContent = {
  title: 'Earning Medallion Status',
  introduction: IntroductionMocks,
  sections: WaysSectionMocks,
  disabled: false,
  loaded: true
};
